import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import AddEditClassModal from './addEditClassModal';
import ArchiveClassModal from './archiveClassModal';
import StartFromLastSlideModal from './startFromLastSlideModal';
import {setLastSlide} from 'actions/sessionActions';
import { Panel } from 'react-bootstrap';
import './sessionPanel.scss';
import projectorIconFile from '../../images/projectorIcon.png';
import buyIconImg from '../../images/buyIcon.png';
import startLevelIconImg from '../../images/startLevel.png';
import Regionalization from 'services/regionalization';
import { i18n } from 'helpers/i18n'

class ActivePanel1 extends Component {
  static propTypes = {
    program: PropTypes.object.isRequired,
    currentLevel: PropTypes.number.isRequired,
    mobile: PropTypes.bool,
    profile: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      activePanel: `${
        props.currentLevel >= Object.keys(props.program.levels).filter(k => parseInt(k, 10)).length
          ? '1'
          : props.currentLevel
      }`
    };
  }

  render() {
    const levelKeys = Object.keys(this.props.program.levels).filter(k => parseInt(k, 10));
    const { i18n: _ } = this.props;
    return <div className={`activePanel1 ${this.props.mobile ? 'mobileActivePanel' : ''}`}>
      <div className="col-md-12 col-sm-12 col-xs-12 program-title-panel">
        {_(this.props.program.title)} {_('Overview')}
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: '0'}} >
        <div
          className="program-description-btn-panel col-md-12 col-sm-12 col-xs-12"
          style={{marginTop: '10px'}}
        >
          <div className="col-md-5 col-sm-12 col-xs-12 program-description-level-list">
          {
            levelKeys.map(l => {
              const lvl = this.props.program.levels[l];
              return <div key={l}>
                <div
                  className={`row program-description-panel program-desc-level-btn btn btn-sm col-md-12 col-sm-12 col-xs-12 ${
                    this.state.activePanel === l
                      ? 'activeDescPanelBtn'
                      : 'inactiveDescPanelBtn'
                  }`}
                  onClick={() => this.setState({ activePanel: l })}
                >
                  <div
                    className="col-md-2 col-xs-2"
                    style={{
                      paddingLeft: '5px',
                      paddingRight: '5px'
                    }}
                  >
                    <img
                      src={lvl.overviewThumbnail}
                      style={{
                        height: '52px !important',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                        float: 'left'
                      }}
                    />
                  </div>
                  <div
                    style={{
                      float: 'left',
                      paddingTop: '10px',
                      paddingLeft: '25px',
                      paddingRight: '10px',
                      textTransform: 'none',
                      fontSize: '15px',
                      textAlign: 'left'
                    }}
                    className="col-md-8 col-xs-8"
                  >
                    {_`#${l}:`} {_(lvl.levelName)}
                  </div>
                  <span
                    className={`glyphicon col-md-1 col-xs-1 session-panel-arrow-icon panel-heading-btn-lh  ${
                      this.state.activePanel === l
                        ? ''
                        : 'glyphicon-chevron-right'
                    }`}
                    style={
                      this.state.activePanel === l
                        ? { display: 'none !important' }
                        : {
                            fontSize: '32px',
                            paddingRight: '0',
                            float: 'left'
                        }
                    }
                    ariaHidden="true"
                  />
                </div>
                {
                  this.state.activePanel === l &&
                  <div className="col-md-7 col-sm-12 col-xs-12 program-description-active-panel mobile-program-description-active-panel">
                    <div dangerouslySetInnerHTML={{
                      __html: _(this.props.program.levels[this.state.activePanel].prep)
                        .getAllAsHtmlWithPrefixedUrls(`programPrep/${this.props.program.id}/`, Regionalization.getRegionDataFromProfile(this.props.profile))
                    }}/>
                  </div>
                }
              </div>
            })
          }
          </div>
          <div className="col-md-7 col-sm-12 col-xs-12 program-description-active-panel desktop-program-description-active-panel">
            <div dangerouslySetInnerHTML={{
              __html: _(this.props.program.levels[this.state.activePanel].prep)
                .getAllAsHtmlWithPrefixedUrls(`programPrep/${this.props.program.id}/`, Regionalization.getRegionDataFromProfile(this.props.profile))
            }}/></div>
          </div>
      </div>
    </div>;
  }
}

class ActivePanel2 extends Component {
  static propTypes = {
    program: PropTypes.object.isRequired,
    mobile: PropTypes.bool,
    profile: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };
  render() {
    const { i18n: _ } = this.props;
    return <div className={`activePanel2 ${this.props.mobile ? 'mobileActivePanel' : ''}`}>
      <div className="col-md-12 col-sm-12 col-xs-12 program-title-panel">
        {_('Teacher Resources')}
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: '0', marginBottom: '5px'}} >
        <div className="program-description-panel">
          <div dangerouslySetInnerHTML={{
            __html: _(this.props.program.programPrepMd).getSectionAsHtmlWithPrefixedUrls(
              'Teacher Resources',
              false,
              `programPrep/${this.props.program.id}/`,
              Regionalization.getRegionDataFromProfile(this.props.profile)
            )
          }} />
        </div>
      </div>
    </div>;
  }
}

class ActivePanel3 extends Component {
  static propTypes = {
    program: PropTypes.object.isRequired,
    mobile: PropTypes.bool,
    profile: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };
  render() {
    const { i18n: _ } = this.props;
    return <div className={`activePanel3 ${this.props.mobile ? 'mobileActivePanel' : ''}`}>
      <div className="col-md-12 col-sm-12 col-xs-12 program-title-panel">
        {_('Printables')}
      </div>
      <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: '0'}} >
        <div className="program-description-panel">
          <div dangerouslySetInnerHTML={{
            __html: _(this.props.program.programPrepMd).getSectionAsHtmlWithPrefixedUrls(
              'Printables',
              false,
              `programPrep/${this.props.program.id}/`,
              Regionalization.getRegionDataFromProfile(this.props.profile)
            )
          }} />
        </div>
      </div>
    </div>;
  }
}

@connect(state => ({profile: state.profile}), {setLastSlide})
export default class SessionPanel extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    program: PropTypes.object.isRequired,
    lastSlide: PropTypes.string,
    completedLevel: PropTypes.number,
    grade: PropTypes.string,
    divisionName: PropTypes.string,
    numberOfStudents: PropTypes.number,
    resetEditClassForm: PropTypes.func.isRequired,
    updateSession: PropTypes.func.isRequired,
    pendingApproval: PropTypes.bool,
    hiddenAt: PropTypes.number,
    expanded: PropTypes.bool,
    validUntil: PropTypes.number,
    funding: PropTypes.string,
    displayBuyNowModal: PropTypes.func.isRequired,
    setLastSlide: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    highlightProgramOverview: PropTypes.bool.isRequired,
    language: PropTypes.string
  };

  static contextTypes = {
    setActiveSession: PropTypes.func.isRequired,
    archiveSession: PropTypes.func.isRequired,
    staff: PropTypes.bool,
    userId: PropTypes.string
  };

  constructor (props) {
    super(props);
    this.state = {
      expanded: props.expanded,
      showEditClassModal: false,
      showArchiveClassModal: false,
      showStartFromLastSlideModal: false,
      activePanel: 0,
      language: props.language
    };
    this.i18n = i18n(props.language);
    const { program } = props;
    Object.keys(program.levels).forEach(level => {
      this.state['showPrepareLevel' + level + 'Modal'] = false;
    });
  }

  componentWillReceiveProps (nextProps) {
    this.i18n = i18n(nextProps.language);
    this.setState({
      expanded: nextProps.expanded,
      language: nextProps.language
    });
  }

  setupAV() {
    this.context.setActiveSession(this.props.id, 'prep', this.props.program.id)
  }

  openEditClassModal () {
    const {
      resetEditClassForm,
      language,
      grade,
      divisionName,
      numberOfStudents,
      program
    } = this.props;
    resetEditClassForm({
      program: program.id,
      language,
      grade,
      divisionName,
      numberOfStudents
    });
    this.setState({ showEditClassModal: true });
  }

  closeEditClassModal() {
    this.setState({ showEditClassModal: false });
  }

  openArchiveClassModal () {
    this.setState({ showArchiveClassModal: true });
  }

  closeArchiveClassModal() {
    this.setState({ showArchiveClassModal: false });
  }

  archiveClass (data) {
    const { archiveSession, userId } = this.context;
    const { sessionId } = data;
    const { program } = this.props;
    const { id: programId } = program;
    archiveSession(sessionId, programId, userId);
  }

  editSession (data) {
    const { id, updateSession, program } = this.props;
    const { id: programId } = program;
    const { language, grade, divisionName, numberOfStudents } = data;
    const userId = this.context.userId;
    updateSession(id, programId, {
      language,
      grade,
      divisionName,
      numberOfStudents: parseInt(numberOfStudents, 10)
    }, userId);
    this.closeEditClassModal();
  }

  toggleExpanded() {
    this.setState({expanded: !this.state.expanded});
  }

  displayStartFromLastSlideModal(level) {
    this.setState({ showStartFromLastSlideModal: true, level });
  }

  hideStartFromLastSlideModal() {
    this.setState({ showStartFromLastSlideModal: false, level: null });
  }

  launchLevel(level) {
    const {lastSlide} = this.props;
    if (!lastSlide) {
      this._launchLevel(level);
    } else {
      this.displayStartFromLastSlideModal(level);
    }
  }

  _launchLevel(level, fromBeginning) {
    const {setActiveSession} = this.context;
    (fromBeginning
      ? this.props.setLastSlide({sessionId: this.props.id})
      : Promise.resolve())
      .then(() => setActiveSession(this.props.id, level, this.props.program.id));
  }

  displayBuyNowModal() {
    const { id: sessionId, program } = this.props;
    const { id: programId, title: programName } = program;
    const _ = this.i18n;
    this.props.displayBuyNowModal(sessionId, programId, _(programName));
  }

  render () {
    const { showEditClassModal, showArchiveClassModal } = this.state;
    const {
      id,
      program,
      divisionName,
      completedLevel
    } = this.props;
    const _ = this.i18n;

    const panelTitle = (
      <div className="panel-title clearfix" style={{cursor: "pointer !important"}}>
        <div className="col-md-4 col-sm-6 col-xs-6 program-class-name-container" onClick={::this.toggleExpanded}>
          <span className="panel-title-text panel-heading-lh program-title-row row">
            {_('Program:')} <span className="programTitleSpan">{_(program.title)}</span>
          </span>
          <span className="panel-title-text panel-heading-lh program-title-row row">
            {_('Class/Division:')} <span className="programTitleSpan">{divisionName}</span>
          </span>
        </div>
        <div className="col-md-4 level-bar-container" onClick={::this.toggleExpanded}>
          <div className="level-progress-bar-container">
            <div
              className="level-progress-bar-bar"
              style={{
                width: typeof(completedLevel) === "number"
                  ? `${Math.floor((
                      completedLevel / Object.keys(program.levels)
                      .filter(k => parseInt(k, 10))
                      .length
                    ) * 100)}%`
                  : "0%"
              }}
            />
          </div>
        </div>
        <span className="btn-group col-md-2 col-sm-6 col-xs-6 panel-buttons">
          <span
            className="glyphicon glyphicon-pencil col-md-4 panel-heading-btn-lh"
            ariaHidden="true"
            style={{cursor: 'pointer'}}
            title="Edit Class"
            onClick={::this.openEditClassModal}
          />
          <AddEditClassModal
            programs={[program]}
            showModal={showEditClassModal}
            onSubmit={::this.editSession}
            closeModal={::this.closeEditClassModal}
            edit
          />
          <span
            className="glyphicon glyphicon-remove col-md-4 panel-heading-btn-lh"
            ariaHidden="true"
            title="Archive Class"
            style={{cursor: 'pointer'}}
            onClick={::this.openArchiveClassModal}
          />
          <ArchiveClassModal
            sessionId={id}
            divisionName={divisionName}
            showModal={showArchiveClassModal}
            onSubmit={::this.archiveClass}
            closeModal={::this.closeArchiveClassModal}
            i18n={this.i18n}
          />
          <span
            className={`glyphicon col-md-4 panel-heading-btn-lh ` + (this.state.expanded ? `glyphicon-chevron-up` : `glyphicon-chevron-down`)}
            ariaHidden="true"
            title={this.state.expanded ? `Collapse` : `Expand`}
            style={{cursor: 'pointer'}}
            onClick={::this.toggleExpanded}
          />
        </span>
      </div>
    );

    const isPendingApproval = this.props.pendingApproval && !this.props.referrerUserId;
    const isRejected = (!this.props.pendingApproval && ((typeof(this.props.funding) === "undefined") || (typeof(this.props.funding) === "object") || this.props.funding === 'CANCELLED')) && !this.context.staff;
    const isExpired = (!this.props.pendingApproval && ((this.props.funding === "STRIPE") || (this.props.funding === "CONTRACT")) && ((new Date(this.props.validUntil)) < (new Date()))) && !this.context.staff;

    const currentLevel = typeof(completedLevel) === 'number' ? completedLevel + 1 : 1;
    return (
      <Panel
        header={panelTitle}
        collapsible
        expanded={this.state.expanded}
        className="col-xs-12 col-sm-12"
        style={{
          paddingLeft: '0',
          paddingRight: '0'
        }}
      >
        <div className="col-md-4 program-thumb program-thumb-my-classes">
          <img src={
            isPendingApproval || isRejected
              ? _(program.trialImageThumb)
              : isExpired
                ? _(program.expiredImageThumb)
                : _(program.thumbnailImage)
          } />
          <StartFromLastSlideModal
            showModal={this.state.showStartFromLastSlideModal}
            closeModal={::this.hideStartFromLastSlideModal}
            startFromBeginning={() => this._launchLevel(this.state.level, true)}
            startFromLastSlide={() => this._launchLevel(this.state.level, false)}
            level={this.state.level}
            i18n={this.i18n} />
        </div>
        <div className="col-md-4 program-step-container">
          <div
            className={
              `program-step col-md-12 col-sm-12 col-xs-12 btn btn-default session-panel-numb-btn${
                this.state.activePanel === 1
                  ? ' activePanelBtn'
                  : ''
              }${this.props.highlightProgramOverview
                  ? ' blink-border'
                  : ''
                }`
            }
            style={{marginTop: '0'}}
            onClick={() => {
              this.state.activePanel === 1
                ? this.setState({ ...this.state, activePanel: 0 })
                : this.setState({ ...this.state, activePanel: 1 })
            }}
          >
            <div className="number-circle">1</div>
            <div className="session-panel-btn-text">{_('Program Overview')}</div>
            <div className="session-panel-arrow-icon-container">
              <span
                className={`glyphicon session-panel-arrow-icon ${
                  this.state.activePanel === 1
                    ? 'glyphicon-chevron-down'
                    : 'glyphicon-chevron-right'
                }`}
              />
            </div>
          </div>
          {
            this.state.activePanel === 1 &&
            <ActivePanel1 profile={this.props.profile} program={program} currentLevel={currentLevel} mobile i18n={this.i18n} />
          }
          <div
            className={`program-step row col-md-12 col-sm-12 col-xs-12 btn btn-default session-panel-numb-btn ${
              this.state.activePanel === 2
                ? 'activePanelBtn'
                : ''
            }`}
            onClick={() => {
              this.state.activePanel === 2
                ? this.setState({ ...this.state, activePanel: 0 })
                : this.setState({ ...this.state, activePanel: 2 })
            }}
          >
            <div className="number-circle">2</div>
            <div className="session-panel-btn-text">{_('Teacher Resources')}</div>
            <div className="session-panel-arrow-icon-container">
              <span
                className={`glyphicon session-panel-arrow-icon ${
                  this.state.activePanel === 2
                    ? 'glyphicon-chevron-down'
                    : 'glyphicon-chevron-right'
                }`}
              />
            </div>
          </div>
          {
            this.state.activePanel === 2 &&
            <ActivePanel2 profile={this.props.profile} program={program} mobile i18n={this.i18n} />
          }
          <div
            className={`program-step row col-md-12 col-sm-12 col-xs-12 btn btn-default session-panel-numb-btn ${
              this.state.activePanel === 3
                ? 'activePanelBtn'
                : ''
            }`}
            style={{marginBottom: '5px'}}
            onClick={() => {
              this.state.activePanel === 3
                ? this.setState({ ...this.state, activePanel: 0 })
                : this.setState({ ...this.state, activePanel: 3 })
            }}
          >
            <div className="number-circle">3</div>
            <div className="session-panel-btn-text">{_('Printables')}</div>
            <div className="session-panel-arrow-icon-container">
              <span
                className={`glyphicon session-panel-arrow-icon ${
                  this.state.activePanel === 3
                    ? 'glyphicon-chevron-down'
                    : 'glyphicon-chevron-right'
                }`}
              />
            </div>
          </div>
          {
            this.state.activePanel === 3 &&
            <ActivePanel3 profile={this.props.profile} program={program} mobile i18n={this.i18n} />
          }
        </div>
        <div className="col-md-4 col-sm-12 col-xs-12 program-launch-container">
          {
            isRejected
              ? <div>
                  <div
                    className="program-launch btn btn-default session-panel-btn col-sm-12 col-xs-12 col-md-5 fundedProjectorIcon"
                    onClick={() => {
                      if (!completedLevel) {
                        ::this.setupAV();
                      }
                    }}
                    style={{ float: 'left' }}
                  >
                    <img
                      src={projectorIconFile}
                      style={{
                        marginTop: '5px',
                        marginBottom: '5px'
                      }}
                    />
                    <span>{_('Set Up Presentation')}</span>
                  </div>
                  <div
                    className="program-launch col-md-7 col-sm-12 col-xs-12 btn btn-default session-panel-btn sessionPanelImgIcon"
                    onClick={::this.displayBuyNowModal}
                    style={{ float: 'right' }}
                  >
                    <img
                      src={buyIconImg}
                      style={{
                        marginTop: '15px',
                        marginBottom: '15px'
                      }}
                    />
                  </div>
                </div>
              : <div
                  className="program-launch btn btn-default session-panel-btn col-sm-12 col-xs-12 col-md-12 fundedProjectorIcon"
                  onClick={() => {
                    if (isExpired || (isPendingApproval && completedLevel >= 1)) {
                      // Do nothing
                    } else {
                      ::this.setupAV()
                    }
                  }}
                >
                  <img src={projectorIconFile} />
                  <span>{_('Set Up Presentation')}</span>
                </div>
          }
          <div
            className={
              `program-launch col-md-12 col-sm-12 col-xs-12 btn btn-primary btn-wrap session-panel-launch-btn sessionPanelLaunchImgIcon ${
              ((isPendingApproval && completedLevel >= 1) || (isRejected && completedLevel >= 1) || isExpired)
                ? "rejectedLaunchBtn"
                : ""
            }`}
            onClick={() => {
              if (isExpired || (isPendingApproval && completedLevel >= 1) || (isRejected && completedLevel >= 1)) {
                // Do nothing
              } else if (completedLevel >= Object.keys(program.levels).filter(k => parseInt(k, 10)).length) {
                ::this.launchLevel('completed')
              } else {
                ::this.launchLevel(currentLevel)
              }
            }}
            style={{
              marginBottom: '0',
              height: '69.6%'
            }}
          >
            <img src={startLevelIconImg} />
            <div className="row">
              {
                isExpired
                  ? _('Access Expired')
                  : isPendingApproval && completedLevel >= 1
                    ? _('Access Pending')
                    : isRejected && completedLevel >= 1
                      ? _('Buy To Unlock')
                      : completedLevel >= Object.keys(program.levels).filter(k => parseInt(k, 10)).length
                        ? _('Re-Enter')
                        : _`Start Module ${currentLevel}`
              }
            </div>
          </div>
        </div>
        {
          this.state.activePanel === 1
            ? <ActivePanel1 profile={this.props.profile} program={program} currentLevel={currentLevel} i18n={this.i18n} />
            : this.state.activePanel === 2
              ? <ActivePanel2 profile={this.props.profile} program={program} i18n={this.i18n} />
              : this.state.activePanel === 3
                ? <ActivePanel3 profile={this.props.profile} program={program} i18n={this.i18n} />
                : <div/>
        }
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/sessionPanel.jsx